import { render, staticRenderFns } from "./ClassList.vue?vue&type=template&id=396fc191&scoped=true&"
import script from "./ClassList.vue?vue&type=script&lang=js&"
export * from "./ClassList.vue?vue&type=script&lang=js&"
import style0 from "./ClassList.vue?vue&type=style&index=0&id=396fc191&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396fc191",
  null
  
)

export default component.exports